import { render, staticRenderFns } from "./TemplateTagEditionModal.vue?vue&type=template&id=6b81adaf&scoped=true"
import script from "./TemplateTagEditionModal.vue?vue&type=script&lang=js"
export * from "./TemplateTagEditionModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateTagEditionModal.vue?vue&type=style&index=0&id=6b81adaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b81adaf",
  null
  
)

export default component.exports